<template>
    <div class="row relative">
        <div class="mb-7 col-xs-6" v-for="image in images" :key="image.id">
            <div class="relative img-container cursor-pointer">
                <img
                    :src="image.small_image_url"
                    :alt="image.alt_description"
                    @click.prevent="$emit('submitImage', image)"
                    class="unsplash-image rounded w-100 object-cover"
                />
                <a
                    :href="image.url"
                    target="_blank"
                    class="absolute bg-grey-600 text-white attribution z-10 rounded-b"
                >
                    {{ image.user_name }} on Unsplash
                </a>
            </div>
        </div>
        <preloader class="absolute h-full w-full bg-white opacity-50" v-if="loading" />
    </div>
</template>

<script>
import Preloader from "@/system/components/global/Preloader";
export default {
    components: { Preloader },
    props: {
        images: {
            type: Array,
            default: () => [],
        },

        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
}
</script>

<style scoped lang="scss">
.img-container {
    .unsplash-image {
        height: 150px;
    }
    .attribution {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 2px 5px;
        opacity: 0;
        font-size: 12px;
    }
    &:hover {
        .unsplash-image {
            opacity: 0.8;
        }
        .attribution {
            opacity: 1;
        }
    }
}
</style>
